/* global jQuery Cookies */
(function ($) {
    $(document).ready(function () {
        if (!Cookies.get('s_uuid')) {
            $.getJSON('https://aws-dev-api.800loanmart.com/uuid', function (data) {
                Cookies.set('s_uuid', data['uuid'], {expires: 90});
            })
        }
    })
})(jQuery);
